import { utcToZonedTime } from 'date-fns-tz';

export const utcDateToLocal = (date: string | Date): Date => utcToZonedTime(date, Intl.DateTimeFormat().resolvedOptions().timeZone);
